import React from "react";
import Scaler from "../dash/components/scaler/Scaler";
import DashPage from "../dash/DashPage";
import styles from "./styles";
import { useTranslation } from "react-i18next";

const ComplaintsPage = () => {
    const { t } = useTranslation();
    return <DashPage>
        <div style={styles.wrapper}>
            <div style={styles.container}>
                <div style={{ textAlign: "left" }}>
                    <Scaler><div><h1 style={styles.title}>{t("complaints.title")}</h1></div></Scaler>
                    <Scaler><div><span style={styles.message}>{t("complaints.message")}</span></div></Scaler>
                </div>
            </div>
        </div>
    </DashPage>
}

export default ComplaintsPage;